define(["data/config"], function(config) {
    var apply = function($element, params) {
        var $number = $element.find("input[type=number]");
        var max = $number.attr("max") ? $number.attr("max") : 99999;
        var min = $number.attr("min") ? $number.attr("min") : -99999;

        var addToVal = function(add) {
            var current = parseInt($number.val());
            if (add > 0 && current + 1 <= max) {
                $number.val(current + 1).trigger("change");
            }
            if (add < 0 && current - 1 >= min) {
                $number.val(current - 1).trigger("change");
            }
        };

        $element.on(config.events.uiInputStepperUp, function() {
            addToVal(+1);
        });
        $element.on(config.events.uiInputStepperDown, function() {
            addToVal(-1);
        });
    };

    return {
        name: "uiInputWrapper--stepper",
        apply: apply
    };
});
